<template>
  <div
    class="my-1-5 flex w-full justify-between rounded border-gray-200 p-2-5 sm:my-2-5 sm:px-6"
    :class="[
      selectedFile || currentFile ? 'border' : 'border-2 border-dashed sm:py-10'
    ]"
  >
    <div class="flex items-center justify-start">
      <icon-base height="40" width="40" icon="file" />
      <span
        :class="`text-tiny-xs pl-1-5 font-medium text-gray-500 sm:pl-5 sm:text-sm ${
          currentFile && currentFile.original_name ? 'cursor-pointer' : ''
        }`"
        @click="handleW9Download"
      >
        {{
          selectedFile
            ? selectedFile.name
            : currentFile
              ? currentFile.original_name
              : uploadDescription
        }}
      </span>
    </div>
    <div
      class="cursor-pointer justify-end place-self-center text-xxs font-medium text-primary sm:text-sm"
    >
      <label class="cursor-pointer">
        {{ selectedFile || currentFile ? "Upload new" : btnLabel }}
        <input
          id="file-upload"
          name="file-upload"
          type="file"
          class="sr-only"
          :value="fileName"
          :accept="accept"
          @input="emitFileUpdated"
        />
      </label>
    </div>
  </div>
</template>
<script type="text/javascript">
import { ref } from "vue";
import { downloadFile } from "@/helpers/files";

export default {
  props: {
    btnLabel: {
      type: String,
      default: "Upload"
    },
    uploadDescription: {
      type: String,
      default: null
    },
    currentFile: {
      type: Object,
      default: null
    },
    accept: {
      type: String,
      default: "*"
    }
  },
  setup(props, { emit }) {
    const selectedFile = ref(null);

    const handleW9Download = async () => {
      if (props.currentFile && props.currentFile.original_name) {
        await downloadFile(
          props.currentFile.file_url,
          {},
          props.currentFile.original_name
        );
      }
    };

    return {
      selectedFile,
      handleW9Download,
      emitFileUpdated: (event) => {
        selectedFile.value = event.target.files[0];
        emit("fileUploaded", event);
      }
    };
  }
};
</script>
